
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";
import { InventoryModState } from "./state";

export const mutations = {
    setInventoryItems(state, payload) {
        state.inventoryItems = payload;
    },
    setInventoryItem(state, payload) {
        const idx = state.inventoryItems.findIndex((v) => {
            return v.id === payload.id;
        });

        if (idx >= 0) {
            state.inventoryItems[idx] = payload;
        } else {
            state.inventoryItems.push(payload);
        }
    },
    removeInventoryItem(state, payload) {
        const idx = state.inventoryItems.findIndex((v) => {
            return v.id === payload.id;
        });
        if (idx >= 0) {
            state.inventoryItems.splice(idx, 1);
        }
    },
    setSelectedBranchId(state, payload) {
        state.selectedBranchId = payload;
    },
    // ===============Transaction Batch ======================================
    setTransactionBatch(state, payload) {
        state.inventoryTransactionBatch = payload;
    },
    addTransaction(state, payload) {
        state.inventoryTransactions.push(payload);
    },
    removeTransaction(state, payload) {
        const idx = state.inventoryTransactions.findIndex((v) => {
            return v.id === payload.id;
        });
        if (idx >= 0) {
            state.inventoryTransactions.splice(idx, 1);
        }
    },
    updateTransaction(state, payload) {
        const idx = state.inventoryTransactions.findIndex((v) => {
            return v.id === payload.id;
        });
        if (idx >= 0) {
            state.inventoryTransactions[idx] = payload;
        }
    },
    setTransactions(state, payload) {
        state.inventoryTransactions = payload;
    }


};

export const { commit } = getStoreAccessors<InventoryModState, State>("");

export const commitSetInventoryItems = commit(mutations.setInventoryItems);
export const commitSetInventoryItem = commit(mutations.setInventoryItem);
export const commitRemoveInventoryItem = commit(mutations.removeInventoryItem);
export const commitSetSelectedBranchId = commit(mutations.setSelectedBranchId);
export const commitSetTransactionBatch = commit(mutations.setTransactionBatch);
export const commitAddTransaction = commit(mutations.addTransaction);
export const commitRemoveTransaction = commit(mutations.removeTransaction);
export const commitUpdateTransaction = commit(mutations.updateTransaction);
export const commitSetTransactions = commit(mutations.setTransactions);
